import * as React from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

function AsideLeft2({ selectedDisease, onDiseaseChange }) {
    const [isAsideVisible, setAsideVisible] = useState(false);
    const [showInfo, setShowInfo] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const path = window.location.pathname;
        const matched = Object.values(diseaseConfig).find((d) =>
            [d.homeUrl, d.mapUrl, d.tableUrl, d.graphUrl].some((url) =>
                path.includes(url)
            )
        );
        if (matched && matched.key !== selectedDisease) {
            onDiseaseChange?.(matched.key);
        }
    }, []);

    useEffect(() => {
        function handleResize() {
            setAsideVisible(window.innerWidth > 1024);
        }
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleAsideVisibility = () => setAsideVisible(!isAsideVisible);

    const handleClick = (event) => {
        event.preventDefault();
        setShowInfo(!showInfo);
    };

    const diseaseConfig = {
        fireblight: {
            key: 'fireblight',
            label: '과수화상병',
            baseURL: 'https://disease.scnu.ac.kr/',
            homeUrl: '/fblight',
            mapUrl: '/fblightmap',
            tableUrl: '/fblighttable',
            graphUrl: '/fblightgraph',
        },
        rblast: {
            key: 'rblast',
            label: '도열병',
            baseURL: 'https://disease.scnu.ac.kr/',
            homeUrl: '/rblast',
            mapUrl: '/rblastmap',
            tableUrl: '/rblasttable',
            graphUrl: '/rblastgraph',
        },
        pwilt: {
            key: 'pwilt',
            label: '소나무재선충병',
            baseURL: 'https://disease.scnu.ac.kr/',
            homeUrl: '/pwilt',
            mapUrl: '/pwiltmap',
            tableUrl: '/pwilttable',
            graphUrl: '/pwiltgraph',
        },
    };

    const currentDisease = diseaseConfig[selectedDisease] || diseaseConfig.fireblight;

    const selectDisease = (diseaseKey) => {
        if (onDiseaseChange) onDiseaseChange(diseaseKey);
        navigate(diseaseConfig[diseaseKey].homeUrl); // ← homeUrl로 이동
    };

    return (
        <>
            <nav id="navbar-main" className="navbar is-fixed-top">
                <div className="navbar-brand">
                    <button
                        type="button"
                        className="navbar-item mobile-aside-button"
                        onClick={toggleAsideVisibility}
                        style={{
                            left: !isAsideVisible || window.innerWidth > 1024 ? '' : '15rem',
                        }}
                    >
                        <span className="icon">
                            <i className={`mdi ${isAsideVisible ? 'mdi-backburger' : 'mdi-forwardburger'} mdi-24px`}></i>
                        </span>
                    </button>
                </div>
            </nav>

            {isAsideVisible && (
                <aside className="aside is-placed-left is-expanded">

                    <img
                        onClick={() => (window.location.href = 'https://disease.scnu.ac.kr/')}
                        src={`${process.env.PUBLIC_URL}/NPDT로고.png`}
                        alt="Logo"
                        style={{
                            width: '150px',
                            marginBottom: '10px',
                            marginTop: '20px',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            cursor: 'pointer',
                        }}
                    />

                    <span className="inline-flex items-center gap-2 rounded-full bg-brand/10 text-brand-dark px-3 py-1 text-xs font-semibold tracking-wide">
                        <span className="w-1.5 h-1.5 rounded-full bg-brand animate-pulse"></span>
                        NPDT · News-based Plant Disease Tracker
                    </span>

                    <div className="menu is-menu-main" style={{ marginTop: '20px' }}>
                        <p className="menu-label">Select Disease</p>
                        <ul className="menu-list" style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                            {Object.values(diseaseConfig).map((d) => {
                                const active = selectedDisease === d.key;
                                return (
                                    <li key={d.key}>
                                        <button
                                            type="button"
                                            onClick={() => selectDisease(d.key)}
                                            style={{
                                                width: '100%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                padding: '10px 14px',
                                                border: `1px solid ${active ? '#4ade80' : 'rgba(255,255,255,0.08)'}`,
                                                borderRadius: '10px',
                                                background: active
                                                    ? 'linear-gradient(135deg, rgba(74,222,128,0.15), rgba(34,197,94,0.08))'
                                                    : 'rgba(255,255,255,0.03)',
                                                color: active ? '#4ade80' : '#9ca3af',
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease',
                                                fontSize: '0.875rem',
                                                fontWeight: active ? 600 : 400,
                                            }}
                                            onMouseEnter={(e) => {
                                                if (!active) {
                                                    e.currentTarget.style.background = 'rgba(255,255,255,0.07)';
                                                    e.currentTarget.style.color = '#e5e7eb';
                                                }
                                            }}
                                            onMouseLeave={(e) => {
                                                if (!active) {
                                                    e.currentTarget.style.background = 'rgba(255,255,255,0.03)';
                                                    e.currentTarget.style.color = '#9ca3af';
                                                }
                                            }}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                <span
                                                    style={{
                                                        width: '8px',
                                                        height: '8px',
                                                        borderRadius: '50%',
                                                        background: active ? '#4ade80' : '#4b5563',
                                                        flexShrink: 0,
                                                        boxShadow: active ? '0 0 6px #4ade80' : 'none',
                                                        transition: 'all 0.2s ease',
                                                    }}
                                                />
                                                <span>{d.label}</span>
                                            </div>
                                            {/* {active && (
                                                <span style={{ fontSize: '0.7rem', opacity: 0.7 }}>선택됨</span>
                                            )} */}
                                        </button>
                                    </li>
                                );
                            })}
                        </ul>

                        <p className="menu-label">Search</p>
                        <ul className="menu-list">
                            <li className="--set-active-tables-html">
                                <Link to={currentDisease.mapUrl}>
                                    <span className="icon">
                                        <i className="mdi mdi-square-edit-outline"></i>
                                    </span>
                                    <span className="menu-item-label">지도</span>
                                </Link>
                            </li>
                            <li className="--set-active-forms-html">
                                <Link to={currentDisease.tableUrl}>
                                    <span className="icon">
                                        <i className="mdi mdi-table"></i>
                                    </span>
                                    <span className="menu-item-label">뉴스 기사</span>
                                </Link>
                            </li>
                            <li className="--set-active-forms-html">
                                <Link to={currentDisease.graphUrl}>
                                    <span className="icon">
                                        <i className="mdi mdi-chart-bar"></i>
                                    </span>
                                    <span className="menu-item-label">기사 년도별 발생횟수</span>
                                </Link>
                            </li>
                        </ul>

                        <p className="menu-label">Related information</p>
                        <ul className="menu-list">
                            <li>
                                <a href="https://www.rda.go.kr/main/mainPage.do" className="has-icon" target="_blank" rel="noopener noreferrer">
                                    <span className="icon"><i className="mdi mdi-web"></i></span>
                                    <span className="menu-item-label">농촌진흥청</span>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.mafra.go.kr/sites/home/index.do" className="has-icon" target="_blank" rel="noopener noreferrer">
                                    <span className="icon"><i className="mdi mdi-web"></i></span>
                                    <span className="menu-item-label">농림축산검역본부</span>
                                </a>
                            </li>
                            <li>
                                <a href="https://ncpms.rda.go.kr/npms/Main.np" className="has-icon" target="_blank" rel="noopener noreferrer">
                                    <span className="icon"><i className="mdi mdi-web"></i></span>
                                    <span className="menu-item-label">병해충관리시스템</span>
                                </a>
                            </li>
                            <li>
                                <a href="https://pdoc.scnu.ac.kr/" className="has-icon" target="_blank" rel="noopener noreferrer">
                                    <span className="icon"><i className="mdi mdi-web"></i></span>
                                    <span className="menu-item-label">인공지능 식물의사</span>
                                </a>
                            </li>
                        </ul>

                        <p className="menu-label">About</p>
                        <ul className="menu-list">
                            <li>
                                <a href="#" className="has-icon" onClick={handleClick}>
                                    <span className="icon"><i className="mdi mdi-help-circle"></i></span>
                                    <span className="menu-item-label">About</span>
                                </a>
                            </li>
                            {showInfo && (
                                <li style={{ marginTop: '10px', marginLeft: '15px' }}>
                                    <p style={{ color: 'rgba(209,213,219)' }}>버그 및 문의</p>
                                    <p style={{ color: 'rgba(209,213,219)' }}>Phone: 010-2259-7161</p>
                                    <p style={{ color: 'rgba(209,213,219)' }}>Email: hope9901@naver.com</p>
                                </li>
                            )}
                        </ul>
                    </div>
                </aside>
            )}
        </>
    );
}

export default AsideLeft2;